<!--
  Vue file for the AI readiness check tool page.
  @author Yannik Sprengart, Adrian Rebmann
-->

<template>
  <div class="kircWrapper" id="kirc">
    <!-- Particle bg -->
    <div class="particles"></div>

    <!-- Questions -->

    <div v-if="kirc" class="md-layout md-alignment-top-center">
      <div
        class="
          md-layout-item
          md-size-5
          md-medium-size-10
          md-small-size-100
          md-xsmall-size-100
        "
      >
        <!-- Back Button on Result Page -->
        <md-button v-if="showResult" @click="showResult = false" class="md-fab">
          <md-icon>arrow_back</md-icon>
        </md-button>
      </div>
      <div
        class="
          md-layout-item
          md-size-80
          md-medium-size-95
          md-small-size-95
          md-xsmall-size-100
        "
      >
        <!-- Question Area -->
        <md-card class="mainFormCard md-elevation-16" v-if="!showResult">
          <md-card-header class="header-wrapper">
            <div class="headlineWrapper">
              <div class="md-layout">
                <div class="md-layout-item md-size-50">
                  <div class="md-display-2 mainHeadline">
                    KI-Readiness-Check
                  </div>
                </div>
                <div align="right" class="md-layout-item md-size-50">
                  <md-button
                    to="/readinesscheck/res"
                    class="Secondary md-raised"
                  >
                    <span class="buttonText"> Ergebnis laden </span>
                  </md-button>
                </div>
              </div>
            </div>
              <div class="progressbar-wrapper">
                <md-progress-bar
                  md-mode="determinate"
                  :md-value="kircProgress"
                  style="transform: scaleY(6);"
                ></md-progress-bar>
              </div>
              <p class="progressbar-content">{{ kircProgress }}%</p>
          </md-card-header>

          <md-card-content>
            <md-steppers
              id="kircStepper"
              md-vertical
              :md-active-step.sync="active"
            >
              <div v-for="(item, key) in kirc" :key="key">
                <md-step @click="scrollToTop()" :md-label="key" :id="key">
                  <div v-for="(question, index) in item" :key="question.name">
                    <!-- TODO: Ask Kai about this prop -->
                    <div class="questionWrapper" v-if="!question.optional">
                      <!-- Location -->
                      <div
                        v-if="
                          question.name ==
                          'Wie lautet die Postleitzahl Ihres Unternehmens?'
                        "
                      >
                        <h3 class="singleQuestion">
                          {{
                            question.newidx +
                            ". Wo ist Ihr Unternehmen zu Hause?"
                          }}
                        </h3>
                        <h5>Diese Angaben sind optional</h5>

                        <div class="md-layout md-gutter md-alignment-top-left">
                          <div
                            class="
                              md-layout-item
                              md-size-50
                              md-medium-size-50
                              md-small-size-100
                              md-xsmall-size-100
                            "
                          >
                            <md-field>
                              <md-select
                                v-model="bundesland"
                                name="bundesland"
                                id="bundesland"
                                placeholder="Bundesland"
                              >
                                <md-option
                                  :value="key"
                                  v-for="(item, key) in places"
                                  :key="key"
                                  >{{ key }}</md-option
                                >
                              </md-select>
                            </md-field>
                          </div>
                          <div
                            class="
                              md-layout-item
                              md-size-50
                              md-medium-size-50
                              md-small-size-100
                              md-xsmall-size-100
                            "
                          >
                            <md-field v-if="bundesland">
                              <md-select
                                v-model="
                                  kircinstance[key][index].answers[0].input
                                "
                                name="landkreis"
                                id="landkreis"
                                placeholder="Landkreis"
                              >
                                <md-option
                                  :value="lk.plz"
                                  v-for="lk in places[bundesland].landkreis"
                                  :key="lk.name"
                                  >{{ lk.name }}</md-option
                                >
                              </md-select>
                            </md-field>
                          </div>
                        </div>
                      </div>

                      <!-- Alle Fragen ausser Standort -->
                      <div v-else>
                        <h3 class="singleQuestion" style="display: inline-flex;">
                          <div style="width: auto;">{{ question.newidx + ". " + question.name }}</div> 
                          <img src="../../../assets/question-mark.svg" alt="question mark" class="questionMarkIcon">
                            <span class="tooltiptext">Die Datenverfügbarkeit beschreibt, wie leicht und zuverlässig die benötigten Daten für die Entwicklung, das Training und den Betrieb von Künstlicher Intelligenz zugänglich und nutzbar sind.</span>
                        </h3>
                        <h5 v-if="question.type == 'multiple'">
                          Mehrfachauswahl möglich
                        </h5>
                        <div class="md-layout md-gutter md-alignment-top-left">
                          <!-- Dropdown für lange Antworten -->
                          <div
                            id="largeDropdown"
                            v-if="question.answers.length > 11"
                            class="
                              md-layout-item
                              md-size-60
                              md-medium-size-50
                              md-small-size-100
                              md-xsmall-size-100
                              answerBoxes
                              drop
                            "
                          > 
                            <v-select
                              v-model="
                                kircinstance[key][index].answers[0].input
                              "
                              :items="question.answers"
                              item-text="text"
                              item-value="text"
                              label="Antwort"
                              persistent-hint
                              single-line
                            ></v-select>
                          </div>
                          <!-- Normale Checkboxes -->
                          <div
                            v-else
                            class="
                              md-layout-item
                              md-size-20
                              md-medium-size-20
                              md-small-size-100
                              md-xsmall-size-100
                              answerBoxes
                            "
                            v-for="answer in question.answers"
                            :key="answer.text"
                          >
                            <!-- Checkbox - Multiple DESELECT -->
                            <md-checkbox
                              v-if="
                                (answer.name == 'keine Antwort möglich' ||
                                  answer.name ==
                                    'Keine der angegebenen Möglichkeiten.') &&
                                question.type == 'multiple'
                              "
                              @change="deselect(key, index)"
                              v-model="kircinstance[key][index].answers"
                              :value="answer"
                              >{{ answer.name }}</md-checkbox
                            >

                            <!-- Checkbox - Nicht Freitext + Multiple  -->
                            <md-checkbox
                              v-else-if="
                                answer.name != 'Freitextantwort' &&
                                question.type == 'multiple'
                              "
                              @change="removeDeselect(key, index)"
                              v-model="kircinstance[key][index].answers"
                              :value="answer"
                              >{{ answer.name }}</md-checkbox
                            >

                            <!-- Checkbox - Nicht Freitext + Kein Multiple -->
                            <md-checkbox
                              v-else-if="
                                answer.name != 'Freitextantwort' &&
                                question.type == null
                              "
                              v-model="kircinstance[key][index].answers[0]"
                              :value="answer"
                              >{{ answer.text }}
                            </md-checkbox>


                            <!-- Freitext-Eingabe -->
                            <md-field
                              v-else-if="
                                (answer.name = 'Freitextantwort') &&
                                (question.type == null) && (kircinstance[key][index].answers[0] != null)
                              "
                              v-for="answerInstance in kircinstance[key][index].answers"
                              :key="answerInstance.hash"
                                v-show="
                                  answerInstance.name ==
                                  'Sonstige*'
                                "
                            >
                              <label>Antwort</label>
                              <md-input
                                v-model="
                                  kircinstance[key][index].answers[0].input
                                "
                              ></md-input>
                            </md-field>
                          </div><!-- div for checkboxes -->

                          <!-- Mit Followup Question -->
                          <div
                            class="
                              md-layout-item
                              md-size-100
                              md-medium-size-100
                              md-small-size-100
                              md-xsmall-size-100
                            "
                            v-if="
                              question.followindices &&
                              question.followindices.length > 0 &&
                              kircinstance[key][index].answers[0] &&
                              kircinstance[key][index].answers[0].causesfollowup
                            "
                          >
                            <div
                              v-for="idx in question.followindices"
                              :key="idx"
                              style="padding-left: 100px; padding-top: 30px"
                            >
                              <h3>{{ item[idx - 1].name }}</h3>
                              <h6 v-if="item[idx - 1].type == 'multiple'">
                                Mehrfachauswahl möglich
                              </h6>
                              <div
                                class="
                                  md-layout md-gutter md-alignment-top-left
                                "
                              >
                                <div
                                  class="
                                    md-layout-item
                                    md-size-20
                                    md-medium-size-20
                                    md-small-size-100
                                    md-xsmall-size-100
                                  "
                                  v-for="followanswer in item[idx - 1].answers"
                                  :key="followanswer.text"
                                >
                                  <md-checkbox
                                    v-if="item[idx - 1].type == 'multiple'"
                                    v-model="kircinstance[key][idx - 1].answers"
                                    :value="followanswer"
                                    >{{ followanswer.text }}</md-checkbox
                                  >

                                  <md-checkbox
                                    v-else
                                    v-model="
                                      kircinstance[key][idx - 1].answers[0]
                                    "
                                    :value="followanswer"
                                    >{{ followanswer.text }}
                                  </md-checkbox>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Mit Followup Question, keine Matrix-Question -->
                          <div
                            class="
                              md-layout-item
                              md-size-100
                              md-medium-size-100
                              md-small-size-100
                              md-xsmall-size-100
                            "
                            v-else-if="
                              question.followup &&
                              kircinstance[key][index].answers[0] &&
                              kircinstance[key][index].answers[0]
                                .causesfollowup &&
                              question.followup !== 'matrix'
                            "
                          >
                            <div style="padding-left: 100px">
                              <h3>{{ question.followup }}</h3>
                              <md-field>
                                <label>Antwort</label>
                                <md-input
                                  v-if="question.followup.includes('Prozent')"
                                  type="number"
                                  v-model="
                                    kircinstance[key][index].answers[0].followup
                                  "
                                ></md-input>
                                <md-input
                                  v-else
                                  v-model="
                                    kircinstance[key][index].answers[0].followup
                                  "
                                ></md-input>
                              </md-field>
                            </div>
                          </div>

                          <!-- Mit Followup Question, die Matrix-Question ist-->
                          <div
                            class="
                              md-layout-item
                              md-size-100
                              md-medium-size-100
                              md-small-size-100
                              md-xsmall-size-100
                            "
                            v-if="
                              question.followup &&
                              kircinstance[key][index].answers[0] &&
                              kircinstance[key][index].answers[0]
                                .causesfollowup &&
                              question.followup === 'matrix'
                            "
                          >
                            <div style="padding-left: 100px">
                              <h3>{{ matrixquestion.question }}</h3>

                              <div
                                class="
                                  md-layout md-gutter md-alignment-top-left
                                "
                              >
                                <div
                                  class="
                                    md-layout-item
                                    md-size-20
                                    md-medium-size-20
                                    md-small-size-100
                                    md-xsmall-size-100
                                  "
                                  v-for="matrixanswer in matrixquestion.answers"
                                  :key="matrixanswer.text"
                                >
                                  <md-checkbox
                                    v-model="
                                      kircinstance[key][index].answers[1]
                                    "
                                    :value="matrixanswer"
                                    >{{ matrixanswer.text }}</md-checkbox
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Button für letzten Schritt -->
                  <div
                    v-if="key == 'Abschließende Fragen'"
                    class="confirmationWrapper"
                  >
                    <div class="questionWrapper"> 
                      <h3 class="singleQuestion">
                              Bitte geben Sie Ihre E-Mail-Adresse an, wenn Sie die Ergebnisse des KI-Readiness-Checks zusätzlich per Mail/als PDF erhalten möchten.
                      </h3>
                      <h5>Diese Angaben sind optional</h5>
                      <md-field style="max-width: 300px;" :class="emailValid">
                        <label>Kontakt E-Mail</label>
                        <md-input v-model="email"></md-input>
                        <span class="md-error">E-Mail Addresse is nicht gültig</span>
                      </md-field>
                    </div>
                  
                    <div>
                      <md-button
                        class="md-accent md-raised nextBtn"
                        @click="setDone(key)"
                        >KIRC Abschließen</md-button
                      >
                    </div>
                    <md-switch v-model="forTesting"
                      >Dies ist ein Testlauf</md-switch
                    >
                  </div>

                  <!-- Button für Steps -->
                  <div v-else class="confirmationWrapper">
                    <div>
                      <md-button
                        class="md-accent md-raised nextBtn"
                        @click="setDone(key)"
                        >Weiter</md-button
                      >
                    </div>
                  </div>
                </md-step>
              </div>
            </md-steppers>
            <div
              class="missedQuestions"
              v-if="
                error &&
                error !=
                  'Sie haben die folgenden Fragen noch nicht beantwortet:<ul></ul>'
              "
              v-html="error"
            ></div>
            <!--md-button class="md-accent md-raised" @click="evaluate();">Auswerten</md-button-->
            <md-progress-bar
              v-if="showProgress"
              class="md-accent"
              md-mode="indeterminate"
            ></md-progress-bar>
          </md-card-content>
        </md-card>

        <!-- RESULT PAGE --->

        <md-card v-if="showResult">
          <md-card-content>
            <div class="md-layout" :class="'md-alignment-top-left'">
              <div
                class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                :class="'md-alignment-top-left'"
              > 
                <div class="stickyHeading__Wrapper">
                  <div class="md-display-1 kiReadinessLevel__H1">
                    Ergebnisse
                  </div>
                  <md-divider></md-divider>
                </div>
              </div>
            </div>
              
            <div class="md-layout" :class="'md-alignment-top-center'">
              <div
                class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                :class="'md-alignment-top-center'"
              >
                <md-card class="CustomCard md-elevation-4">
                  <md-card-content>
                    <!-- centered row of stars -->
                    <div class="stars-wrapper">
                      <img class="star" src="../../../assets/star.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) >= 1">
                      <img class="star" src="../../../assets/star.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) >= 2">
                      <img class="star" src="../../../assets/star.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) >= 3">
                      <img class="star" src="../../../assets/star.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) >= 4">
                      <img class="star" src="../../../assets/star.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) >= 5">
                      <img class="star" src="../../../assets/star_gray.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) < 2">
                      <img class="star" src="../../../assets/star_gray.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) < 3">
                      <img class="star" src="../../../assets/star_gray.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) < 4">
                      <img class="star" src="../../../assets/star_gray.svg" alt="Star" 
                        width="60" height="60" v-if="Math.ceil(finalscore / 68) < 5">
                    </div>
                    <br>
                    <div class="progress-wrapper">
                      <div class="finalScoreWrapper">
                        <h4 class="levelSubheading">Level</h4>
                        <!--h1 id="finalScore">{{(Math.round(finalscore/20))+"/5"}}</h1-->
                        <h1 id="finalScore" class="mb-2">
                          {{ Math.ceil(finalscore / 68) + "/5" }}
                        </h1>
                        <h1
                          slot="textCard__Headline"
                          v-if="Math.ceil(finalscore / 68) === 1"
                        >
                          {{ level1.name }}
                        </h1>
                        <h1
                          slot="textCard__Headline"
                          v-if="Math.ceil(finalscore / 68) === 2"
                        >
                          {{ level2.name }}
                        </h1>
                        <h1
                          slot="textCard__Headline"
                          v-if="Math.ceil(finalscore / 68) === 3"
                        >
                          {{ level3.name }}
                        </h1>
                        <h1
                          slot="textCard__Headline"
                          v-if="Math.ceil(finalscore / 68) === 4"
                        >
                          {{ level4.name }}
                        </h1>
                        <h1
                          slot="textCard__Headline"
                          v-if="Math.ceil(finalscore / 68) === 5"
                        >
                          {{ level5.name }}
                        </h1>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div
                class="md-layout-item md-size-60 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                :class="'md-alignment-top-center'"
              >
              

              <TextCard>
                  <span slot="textCard__Icon">compare_arrows</span>
                  <!--span slot="textCard__Headline">Level {{(Math.round(finalscore/20))}}</span-->
                  <span
                    slot="textCard__Headline">Vergleich zu anderen Unternehmen</span
                  > 
                  <div slot="textCard__Text">
                    <span style="display: block;">
                      Andere Unternehmen Ihrer Branche haben durchschnittlich<br> einen KI-Readiness-Level <span style="font-weight: bold;">{{levelIndustry}}</span>
                        <div class="stars-wrapper">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry >= 1">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry >= 2">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry >= 3">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry >= 4">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry >= 5">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry < 2">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry < 3">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry < 4">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="levelIndustry < 5">
                        </div>
                         erreicht.
                    </span>
                    <span style="display: block;">
                      Andere Unternehmen Ihrer Größe haben durchschnittlich<br> einen KI-Readiness-Level <span style="font-weight: bold;">{{levelSize}}</span>
                      <div class="stars-wrapper">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize >= 1">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize >= 2">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize >= 3">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize >= 4">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize >= 5">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize < 2">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize < 3">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize < 4">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="levelSize < 5">
                        </div>
                      erreicht.
                    </span>
                    <span style="font-size: small;">Basiert auf Auswertung von {{ amountCompaniesComparison }} Unternehmen.</span>
                  </div>
                </TextCard>

                <!-- <RecCard v-if="recEvents.length > 0">
                  <span slot="recCard__Icon">calendar_today</span>
                  <span slot="recCard__Headline">Events</span>
                  <div slot="recCard__Content">
                    <md-table>
                      <md-table-row
                        v-for="(recevent, index) in recEvents"
                        :key="index.recevent"
                      >
                        <md-table-cell>{{ recevent.name }}</md-table-cell>
                        <md-table-cell>{{ recevent.eventdate }}</md-table-cell>
                        <md-table-cell>
                          <a :href="recevent.link" target="_blank">
                            <md-button class="md-accent eventBtn">
                              Mehr Dazu
                              <md-icon>arrow_right_alt</md-icon>
                            </md-button>
                          </a>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </RecCard>

                <RecCard v-if="recEvents.length == 0">
                  <span slot="recCard__Icon">calendar_today</span>
                  <span slot="recCard__Headline">Events</span>
                  <div slot="recCard__Content">
                    Derzeit können wir für Ihr Ergebnis leider keine
                    Empfehlungen anzeigen
                  </div>
                </RecCard>
                <RecCard v-if="recTrainer.length > 0">
                  <span slot="recCard__Icon">people</span>
                  <span slot="recCard__Headline">KI-Trainer</span>
                  <div slot="recCard__Content">
                    <md-table>
                      <md-table-row
                        v-for="(rectrainer, index) in recTrainer"
                        :key="index.rectrainer"
                      >
                        <router-link
                          :to="'/trainerdetail/' + rectrainer.hash"
                          target="_blank"
                          class="no-link"
                        >
                          <md-table-cell class="ki-cell-small">{{
                            rectrainer.name
                          }}</md-table-cell>
                          <md-table-cell class="ki-cell-small">{{
                            rectrainer.competence_center
                          }}</md-table-cell>
                          <md-table-cell class="ki-cell-large">
                            <v-chip
                              small
                              chip
                              class="ma-1"
                              v-for="(
                                mainemphases, index
                              ) in rectrainer.main_emphases"
                              :key="index.mainemphases"
                              >{{ mainemphases.name }}</v-chip
                            >
                          </md-table-cell>
                        </router-link>
                      </md-table-row>
                    </md-table>
                  </div>
                </RecCard>
                <RecCard v-if="recTrainer.length == 0">
                  <span slot="recCard__Icon">people</span>
                  <span slot="recCard__Headline">KI-Trainer</span>
                  <div slot="recCard__Content">
                    Derzeit können wir für Ihr Ergebnis leider keine
                    Empfehlungen anzeigen
                  </div>
                </RecCard> -->
              </div>
            </div>
            
            <div class="md-layout" :class="'md-alignment-top-center'">
              <div
                class="md-layout-item md-size-80 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
                :class="'md-alignment-top-center'"
              >
                <div class="stickyHeading__Wrapper">
                  <div class="md-display-1 kiReadinessLevel__H1">
                    <span>Empfehlungen nach Reifegrad</span>
                  </div>
                  <md-divider></md-divider>
                </div>
                <md-card class="TextCard" v-for="(item, key) in rec" :key="key">
                  <md-card-header class="TextCard__Wrapper">
                    <md-card-header-text class="TextCard__Header">
                      <div class="IconBox">
                        <md-icon class="IconBox__Icon">
                          home
                        </md-icon>
                      </div>
                      <div class="md-title" style="display: flex;">
                        <h5>
                          {{ key }}
                        </h5>
                        <div class="stars-wrapper" style="margin-left: 15px;">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] >= 1">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] >= 2">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] >= 3">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] >= 4">
                          <img class="star-small" src="../../../assets/star.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] >= 5">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] < 2">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] < 3">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] < 4">
                          <img class="star-small" src="../../../assets/star_gray.svg" alt="Star" 
                            width="15" height="15" v-if="reifeGradLevel[key] < 5">
                        </div>
                      </div>
                    </md-card-header-text>
                  </md-card-header>

                  <md-card-content class="TextCard__Content">
                    <div v-for="(item, key) in rec[key]" :key="key">
                      <div class="md-layout md-gutter md-alignment-center-center">
                        <!-- this one is just a placeholder so the reifegrad stays centered. Wacky, i know, but it works :-P -->
                        <div style="visibility: hidden;">
                          <span>{{ item.level }}/5</span>
                        </div>
                        <div class="md-layout-item reifegrad" >
                          <span>{{ item.reife }}</span>
                        </div>
                        <div>
                          <span>{{ item.level }}/5</span>
                        </div>
                      </div>
                      <div class="md-layout md-gutter md-alignment-top-center recommendation_container">
                        <div class="md-layout-item recommendation">
                          <span><span style="font-weight: bold;">Statusbericht: </span> {{ item.zustand }}</span>
                        </div>
                        <div class="md-layout-item recommendation">
                          <span><span style="font-weight: bold;">Empfehlung: </span> {{ item.empfehlung }}</span>
                        </div>
                      </div>
                      <md-divider style="margin-top: 10px; margin-bottom: 10px"></md-divider>
                    </div>
                    

                  </md-card-content>
                </md-card>

              </div>
            </div>
          </md-card-content>
          <md-card-actions class="resultAction-Wrapper">
            <md-button
              to="/readiness-welcome"
              v-if="!loggedIn"
              class="md-raised text-align-left md-primary CTA CTA--newCheck"
            >
              <span class="buttonText">Neuer Check</span>
            </md-button>
            <md-button
              :to="'/readinesscheck/' + resulttoken"
              v-if="!loggedIn"
              class="md-raised md-primary CTA CTA--signup"
            >
              <span class="buttonText">Jetzt Anmelden</span>
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
      <div
        class="
          md-layout-item
          md-size-5
          md-medium-size-10
          md-small-size-100
          md-xsmall-size-100
        "
      ></div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div
      class="
        md-layout-item
        md-size-5
        md-medium-size-10
        md-small-size-100
        md-xsmall-size-100
      "
    ></div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </div>
</template>

<script>
import json from "../../../../static/data.json";
import TextCard from "../kirc/components/TextCard.vue";
import RecCard from "../kirc/components/RecommendationCard.vue";
import ScoreCard from "../kirc/components/ScoreCard.vue";
import auth from "../../../auth";
import {
  postKIRCResult,
  getKIRC,
  getKIRCResult,
  saveResForUser,
} from "../../../api";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "KIRC",
  components: {
    TextCard,
    RecCard,
    ScoreCard,
    Loading,
  },
  data() {
    return {
      loggedIn: auth.loggedIn(),
      places: json,
      bundesland: null,
      landkreis: null,
      keys: [],
      forTesting: false,
      error: null,
      matrixquestion: {
        question: "Waren die Versuche der KI-Einführung erfolgreich?",
        type: "single",
        index: 7,
        isLoading: false,
        answers: [
          {
            text: "nein, überhaupt nicht",
            input: null,
            score: {
              keine: 0,
              vereinzelt: 1,
              einige: 1,
              viele: 1,
              sehrviele: 0,
            },
            index: 1,
            rec: "Identifizieren Sie ein mögliches Anwendungsgebiet und ein dazugehöriges Vorgehensmodell, um eine erste KI-Technologie einführen zu können.",
            tags: ["Veränderungsmanagement"],
          },
          {
            text: "eher nein",
            input: null,
            score: {
              keine: 0,
              vereinzelt: 2,
              einige: 2,
              viele: 1,
              sehrviele: 1,
            },
            index: 2,
            rec: "Dokumentieren Sie das erlangte Wissen der Technologieeinführung in Ihrem Unternehmen und stellen Sie sicher, dass es an andere Mitarbeiter weitergegeben wird.",
            tags: ["Unternehmensprozesse"],
          },
          {
            text: "teilweise",
            input: null,
            score: {
              keine: 0,
              vereinzelt: 3,
              einige: 3,
              viele: 3,
              sehrviele: 2,
            },
            index: 3,
            rec: "Probieren Sie einen neuen Technologieimplementierungsansatz aus und überprüfen Sie, ob alle Technologievoraussetzungen erfüllt sind.",
            tags: ["Digitale Geschäftsmodelle"],
          },
          {
            text: "eher ja",
            input: null,
            score: {
              keine: 0,
              vereinzelt: 4,
              einige: 4,
              viele: 4,
              sehrviele: 4,
            },
            index: 4,
            rec: "Akquirieren Sie geschultes Personal und nutzen Sie spezifische Weiterbildungsmaßnahmen in den betreffenden Themen.",
            tags: [],
          },
          {
            text: "ja, sehr",
            input: null,
            score: {
              keine: 0,
              vereinzelt: 5,
              einige: 5,
              viele: 5,
              sehrviele: 5,
            },
            index: 5,
            rec: "Testen Sie gegebenenfalls die Angebote von Beratungsunternehmen oder Technologieanbietern.",
            tags: [],
          },
          {
            text: "keine Antwort möglich",
            input: null,
            score: {
              keine: 0,
              vereinzelt: 0,
              einige: 0,
              viele: 0,
              sehrviele: 0,
            },
            index: 0,
          },
        ],
      },
      rec: null,
      kirc: null,
      kircinstance: null,
      finalscore: 0,
      showProgress: false,
      showResult: false,
      active: null,
      level1: {
        name: "Novize",
        text: "Voraussetzungen für den Einsatz von KI-Anwendungen sind noch keine erfüllt. Es wurden noch keine KI-Anwendungsszenarien identifiziert. Das Thema KI wird im Unternehmen noch nicht wahrgenommen, auch über eine KI-Strategie hat man sich noch keine Gedanken gemacht. Daten werden in der Regel nur vereinzelt digital erfasst.",
      },
      level2: {
        name: "Erkunder",
        text: "Voraussetzungen für den Einsatz von KI-Anwendungen wurden identifiziert und Potenziale möglicher Anwendungen wurden erkannt. Die Mitarbeiter des Unternehmens beginnen sich für das Thema KI zu interessieren. Perspektivisch soll eine KI-Strategie eingeführt werden. Daten werden in der Regel noch unstrukturiert und dezentral erfasst. Notwendige Kompetenzen zum Umgang mit KI-Anwendungen wurden identifiziert.",
      },
      level3: {
        name: "Entdecker",
        text: "Maßnahmen zur Erfüllung der Voraussetzungen für die KI-Einführung wurden identifiziert. Konkrete Anwendungsszenarien wurden bereits erfasst und die Bereitschaft von Mitarbeitern KI-Projekte mitzutragen ist vereinzelt gegeben. Eine KI-Strategie ist in Planung. Daten werden bereits strukturiert, aber dezentral, erfasst. Die Mitarbeiter des Unternehmens werden beim Kompetenzaufbau im Bereich KI unterstützt.",
      },
      level4: {
        name: "Vorbereiter",
        text: "Maßnahmen, um die Voraussetzungen für KI-Anwendungen zu erfüllen wurden ergriffen. Es wurden konkrete Lösungsansätze für die identifizierten Anwendungsszenarien beschlossen. Die Bereitschaft der Mitarbeiter KI-Projekte mitzugestalten ist vorhanden und die Planung einer KI-Strategie ist abgeschlossen. Daten werden in der Regel zentral und größtenteils strukturiert erfasst. Ein erweitertes Angebot für den Kompetenzaufbau der Mitarbeiter ist vorhanden und wird gegebenenfalls durch die Akquise neuer Mitarbeiter unterstützt.",
      },
      level5: {
        name: "Anwender",
        text: "Die Voraussetzungen für den Einsatz von KI-Anwendungen sind erfüllt und die Umsetzung vereinzelter Anwendungsszenarien läuft. Die Mitarbeiter des Unternehmens sind motiviert KI-Projekte voranzutreiben. Die Umsetzung der KI-Strategie ist bereits angelaufen. Daten werden zentral gespeichert und es werden erste Analysen durchgeführt. Ein individueller Kompetenzaufbau im Bereich KI wird gefördert.",
      },
      recEvents: [],
      recTrainer: [],
      kircResText: "",
      resulttoken: null,
      email: "",
    };
  },
  computed: {
    emailValid () {
      return {
        "md-invalid": this.email.length!=0 && !this.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
      }
    },
    kircProgress() {
      let answered = 0;
      let amount = 0;
      for (let key in this.kircinstance) {
        for (let index in this.kircinstance[key]) {
          amount++;
          if (this.kircinstance[key][index].answers[0] == null || this.kircinstance[key][index].answers[0].text == "") {
            continue;
          }else {
            console.log(this.kircinstance[key][index].answers[0]);
            answered++;
          }
        }
      }
      return Math.floor((answered / amount) * 100);
    }
  },
  updated() {
    //This is a good place for debugging.
  },
  created() {
    this.isLoading = true;
    getKIRC().then((res) => {
      this.kirc = new Object();
      this.kirc["Anwendungsbereiche und Technologien"] = res[
        "Anwendungsbereiche und Technologien"
      ].sort((a, b) => (a.index > b.index ? 1 : -1));
      this.kirc["Prozesse, Strategie und Organisation"] = res[
        "Prozesse, Strategie und Organisation"
      ].sort((a, b) => (a.index > b.index ? 1 : -1));
      this.kirc["Mitarbeiter"] = res["Mitarbeiter"].sort((a, b) =>
        a.index > b.index ? 1 : -1
      );
      this.kirc["Wirtschaftliche Perspektive, Produkte und Dienstleistungen"] =
        res["Wirtschaftliche Perspektive, Produkte und Dienstleistungen"].sort(
          (a, b) => (a.index > b.index ? 1 : -1)
        );
      this.kirc["Abschließende Fragen"] = res["Abschließende Fragen"].sort(
        (a, b) => (a.index > b.index ? 1 : -1)
      );

      let deepClone = JSON.parse(JSON.stringify(this.kirc));
      for (let prop in this.kirc) {
        for (let i = 0; i < this.kirc[prop].length; i++) {
          //For question with follow-up questions.
          if (this.kirc[prop][i].followup.includes("#")) {
            let parts = this.kirc[prop][i].followup.split("#");
            this.kirc[prop][i].followindices = [];
            for (let x = 0; x < parts.length; x++) {
              if (parts[x].length > 0) {
                this.kirc[prop][i].followindices.push(parts[x]);
                this.kirc[prop][parts[x] - 1].optional = true;
              }
            }
          }
        }
      }

      for (let prop in this.kirc) {
        let j = 0;
        for (let i = 0; i < this.kirc[prop].length; i++) {
          if (!this.kirc[prop][i].optional) {
            j++;
            this.kirc[prop][i].newidx = j;
          }

          //Sort the answers according to the index.
          this.kirc[prop][i].answers = this.kirc[prop][i].answers.sort((a, b) =>
            a.index > b.index ? 1 : -1
          );
        }
      }
      // sort industries by name alphabetically
      this.kirc["Abschließende Fragen"][0].answers.sort((a, b) => (a.name > b.name ? 1 : -1));

      // Set kircinstance to sorted Kirc
      this.kircinstance = deepClone;
      for (let prop in this.kircinstance) {
        this.keys.push(prop);

        for (let i = 0; i < this.kircinstance[prop].length; i++) {

          if (this.kircinstance[prop][i].answers.length > 11) {
            this.kircinstance[prop][i].answers = [
              this.kircinstance[prop][i].answers[0],
            ];
          } else if (this.kircinstance[prop][i].answers.length === 1) {
            //console.log(this.kircinstance[prop][i].answers);
          } else if (this.kircinstance[prop][i].type == "multiple") {
            this.kircinstance[prop][i].answers = [];
          } else {
            this.kircinstance[prop][i].answers = [null];
          }
        }
      }
      this.active = this.keys[0];
      this.isLoading = false;
    });
  },
  methods: {
    //Method for removing deselect
    removeDeselect(key, index) {
      for (var i = 0; i < this.kircinstance[key][index].answers.length; i++) {
        if (
          this.kircinstance[key][index].answers[i].text !=
            "Keine der angegebenen Möglichkeiten." &&
          this.kircinstance[key][index].answers[i].text !=
            "keine Antwort möglich"
        ) {
          const newArr = this.kircinstance[key][index].answers.filter(
            (item) =>
              item.text !== "Keine der angegebenen Möglichkeiten." &&
              item.text !== "keine Antwort möglich"
          );

          this.kircinstance[key][index].answers.length = 0;
          this.kircinstance[key][index].answers.push.apply(
            this.kircinstance[key][index].answers,
            newArr
          ); // Append new contents
          break;
        }
      }
    },

    // Method for deselecting on a multiple choice checkbox
    deselect(key, index) {
      for (var i = 0; i < this.kircinstance[key][index].answers.length; i++) {
        if (
          this.kircinstance[key][index].answers[i].text ==
            "Keine der angegebenen Möglichkeiten." ||
          this.kircinstance[key][index].answers[i].text ==
            "keine Antwort möglich"
        ) {
          const newArr = this.kircinstance[key][index].answers.filter(
            (item) =>
              item.text === "Keine der angegebenen Möglichkeiten." ||
              item.text === "keine Antwort möglich"
          );

          this.kircinstance[key][index].answers.length = 0;
          this.kircinstance[key][index].answers.push.apply(
            this.kircinstance[key][index].answers,
            newArr
          ); // Append new contents
          break;
        }
      }
    },
    getNextKey(key) {
      for (let i = 0; i < this.keys.length; i++) {
        if (this.keys[i] == key) {
          return this.keys[i + 1];
        }
      }
      return null;
    },
    setDone(id) {
      this[id] = true;
      let next = this.getNextKey(id);
      if (next) {
        this.active = next;
        this.scrollToTop();
      } else {
        this.evaluate();
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    evaluate() {
      let s = "Sie haben die folgenden Fragen noch nicht beantwortet:<ul>";
      for (let key in this.kircinstance) {
        if (key !== "Abschließende Fragen") {
          for (let index in this.kircinstance[key]) {
            if (
              !(
                this.kircinstance[key][index].answers &&
                this.kircinstance[key][index].answers[0] &&
                this.kircinstance[key][index].answers[0].text
              ) &&
              !this.kirc[key][index].optional
            ) {
              s +=
                "<li>" +
                key +
                ": " +
                this.kircinstance[key][index].name +
                "</li>";
            }
          }
        }
      }
      s += "</ul>";
      this.error = s;
      if (
        s !== "Sie haben die folgenden Fragen noch nicht beantwortet:<ul></ul>"
      )
        return;
      this.showProgress = true;
      let score = 0;
      let maxscore = 0;
      for (let key in this.kircinstance) {
        for (let index in this.kircinstance[key]) {
          maxscore += 5;
          if (
            this.kircinstance[key][index].followup &&
            this.kircinstance[key][index].followup === "matrix" &&
            this.kircinstance[key][index].answers[1]
          ) {
            //console.log(this.kircinstance[key][index].answers[1].text)
            this.kircinstance[key][index].answers[0].score =
              this.kircinstance[key][index].answers[1].score[
                this.kircinstance[key][index].answers[0].text.replace(/\s/g, "")
              ];
            this.kircinstance[key][index].answers[0].input =
              this.kircinstance[key][index].answers[1].text;
            this.kircinstance[key][index].answers.splice(1, 1);
          }
          if (
            this.kircinstance[key][index].answers[0] &&
            this.kircinstance[key][index].answers[0].text
          ) {
            score += this.kircinstance[key][index].answers[0].score;
            if (
              this.kircinstance[key][index].answers[0].text ==
              "keine Antwort möglich"
            ) {
              maxscore -= 5;
            }
          } else {
            this.kircinstance[key][index].answers = [];
            maxscore -= 5;
          }
        }
      }

      this.finalscore = (score * 100) / (27 * 5);

      // For Testing
      if (this.forTesting) {
        this.kircinstance["For Testing"] = [];
      }

      var kircResult = {"tok": this.kircinstance, "contactMail": this.email}
      // console.log(kircResult)

      //TODO: check if this works correctly
      postKIRCResult(kircResult)
        .then((res) => {
          // // TODO Comment Out log
          // console.log("KIRC RES");
          // console.log(res);
          let newrec = {};

          console.log("after removal:");
          for (var key of Object.keys(res.rec)) {
            newrec[key] = res.rec[key].replace("_", "");
            if (newrec[key] == "") {
              delete newrec[key];
            }
          }

          this.recEvents = res.recevents;
          this.recTrainer = res.reckitrainers;
          this.rec = newrec;

          // TODO: change the following 4 values to be loaded from the backend as soon as it is ready
          this.levelIndustry = 3;
          this.levelSize = 2;
          this.amountCompaniesComparison = 3246;
          this.rec = {
              "Organisation": [
                {
                  "level": 2, // the level that this answer suggestion was based on
                  "reife": "Strategie",
                  "zustand": "Ihr Unternehmen hat noch keine KI-Strategie entwickelt oder die Möglichkeit neuer Ansätze erkundet.",
                  "empfehlung": "Führen Sie eine Bedarfsanalyse durch, um zu verstehen, wie KI Ihrem Unternehmen Nutzen bringen kann und initiieren Sie Gespräche, um mögliche strategische Ansätze zu identifizieren."
                },
                {
                  "level": 1,
                  "reife": "Geschäftsmodell",
                  "zustand": "Die Auswirkungen von KI auf Ihr Geschäftsmodell sind umfassend erhoben. Sie wissen auch, welche Bereiche indirekt von KI beeinflusst werden können. ",
                  "empfehlung": "Aktualisieren Sie Ihr Geschäftsmodell regelmäßig und erweitern Sie Ihre Strategie, um auch zukünftige Entwicklungen und innovative KI-Technologien proaktiv in Ihr Geschäftsmodell zu integrieren."
                },
                {
                  "level": 3,
                  "reife": "Kultur",
                  "zustand": "KI wird zunehmend in Entscheidungsprozesse integriert und es wird aktiv geprüft, wie diese Technologien bestehende Lösungen verbessern können.",
                  "empfehlung": "Ermutigen Sie die Mitarbeitenden Feedback zu geplanten oder bestehenden KI-Projekten zu geben. Laden Sie alle relevanten Personen zur Anforderungserhebung aktiver KI-Projekte ein. "
                },
                
              ],
              "Technologie" : [
                {
                  "level": 5,
                  "reife": "Datenverfügbarkeit",
                  "zustand": "Es sind zwar einige Daten vorhanden, aber sie sind entweder unvollständig, veraltet oder nicht für das alle relevanten Stakeholder zugänglich.",
                  "empfehlung": "Identifizieren und schließen Sie bestehende Datenlücken, verbessern Sie das Datenmanagement und investieren Sie in Technologien zur Datenintegration."
                }
              ],
            };
          // compute the average level of each Reifegrad category
          // TODO: maybe include weights in the average level calculation
          this.reifeGradLevel = {};
          let reifegrade = Object.keys(this.rec);
          for(let i = 0; i < reifegrade.length; i++) {
            let grad = reifegrade[i];
            let level_sum = 0;
            for (let j = 0; j < this.rec[grad].length; j++) {
              level_sum += this.rec[grad][j].level;
            }
            this.reifeGradLevel[grad] = Math.round(level_sum / this.rec[grad].length);
          };

          this.finalscore = res.score;
          this.resulttoken = res.hash;
          this.isLoading = false;
          this.kircResText = res.kircResText;
          this.showResult = true;
          this.scrollToTop();
          if (this.loggedIn) {
            //saveResForUser(this.resulttoken)
          }
        })
        .catch(() => {
          window.setTimeout(() => {
            this.showProgress = false;
            this.showResult = true;
            this.scrollToTop();
          }, 3000);
        });
    }
  },
};
/**
 *  RL 1:	 0-20%
 *  RL 2:   21-40%
 *  RL 3:   41-60%
 *  RL 4:   61-80%
 *  RL 5:   81-100%
 */
</script>


<style>
/* TODO: Adjust this */
/* Global Styles */
/* Dropdown Menu Wrapper */
.md-menu-content {
  min-height: auto;
  /* max-width: 300px; */
  max-height: 100vh;
}

.md-checkbox .md-checkbox-label {
  height: 100% !important;
}
</style>


<style scoped>
/* Local Styles */
.kircWrapper {
  margin-top: -20px;
  margin-bottom: -100px;
  padding: 4em 4em 8em 4em;
  min-height: 1000px;
}

.md-steppers.md-vertical .md-stepper-content {
  padding: 0px !important;
}

.particles {
  text-align: center;
  color: #2c3e50;
  background-image: url("../../../assets/particle-bg-min.png");
  background-color: #641b1a;
  box-sizing: border-box;
  background-repeat: repeat;
  background-size: auto;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.answerBoxes {
  padding-bottom: 2em;
  padding-right: 12px;
}

.kiReadinessLevel__H1 {
  text-align: center !important;
  color: #333;
}

.kiReadinessLevel__H1.left-align {
  text-align: left !important;
}

.stars-wrapper {
  position: relative;
  display: inline-flex;
  justify-content: center;
}

.star {
  margin-right: 10px;
}

.star-small {
  margin-right: 2px;
}

.CustomCard {
  border-radius: 15px;
  margin: 18px;
  padding: 0px 18px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.progessWrapper {
  position: relative;
}
.finalScoreWrapper {
    position: relative;
    text-align: center;
    justify-content: center;
}

.questionMarkIcon {
  width: 25px;
  height: 25px;
  margin-left: 20px;
  margin-top: -2px;
  color: white;
}

.singleQuestion:hover .tooltiptext {
  visibility: visible;
}

.tooltiptext {
  visibility: hidden;
  font-size: medium;
  position: relative;
  width: 240px;
  height: 200px;
  background-color: #1a1a1a;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  margin-bottom: -100%;
  z-index: 10000;
}

.mainFormCard {
  max-width: 1300px;
  margin: 0 auto;
  /* padding: 16px; */
}

.questionWrapper {
  background-color: #f1f3f6;
  padding: 2em;
  margin-bottom: 2em;
  border-radius: 6px;
}

.singleQuestion {
  margin: 0px 0px 1em 0px;
}

.headlineWrapper {
  position: relative;
  background-color: #1a1a1a;
  padding: 1em;
  margin: -16px -16px 16px -16px;
  z-index: 9;
}

.mainHeadline {
  color: #fff;
  font-size: 34px;
  line-height: 40px;
}

.progressbar-wrapper {
  position: relative;
  margin: -16px -16px 16px -16px;
  height: 20px;
}

.progressbar-content {
  position: absolute;
  z-index: 10;
  color: white;
  margin-top: -38px;
  margin-left: -5px;
  font-weight: bold;
}

.header-wrapper {
  position: sticky;
  top: 60px;
  z-index: 9;
}

.subHeading {
  font-weight: 500;
}

.nextBtn {
  margin-top: 24px;
}

.missedQuestions {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  background-color: #eb8f8f;
  margin: 18px;
  padding: 18px;
  line-height: 1.6em;
  border-radius: 10px;
}

.missedQuestions ul li {
  color: green;
}

.CTA {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-top: 36px 18px 18px 18px;
  height: 60px;
  width: 180px;
  border-radius: 10px;
  text-transform: none;
}

.CTA.Secondary {
  color: #9a9da8;
}

.Secondary--LoggedIn {
  color: #9a9da8;
}

.Secondary--LoggedIn:hover {
  margin-left: -50px;
  color: #000000;
  background-color: rgba(240, 248, 255, 0);
}

.stickyHeading__Wrapper {
  width: 100%;
  position: sticky;
  top: 0;
  padding: 12px 16px;
  z-index: 9;
  background-color: #fff;
  display: flex;
}

.resultAction-Wrapper {
  padding-right: 30px;
  padding-bottom: 12px;
}

.ki-cell-small {
  width: 25% !important;
}

.ki-cell-large {
  width: 50% !important;
}

.no-link {
  text-decoration: none !important;
  color: black !important;
}

.confirmationWrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.TextCard {
    border-radius: 15px;
    margin: 18px;
    padding: 0px 18px;
  }
  
  .TextCard__Header {
    display: flex;
    align-items: center;
  }
  
  .IconBox {
    height: 45px;
    width: 45px;
    min-height: 45px;
    min-width: 45px;
    border-radius: 15px;
    background-color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    box-shadow: 0 0.6px 2.2px rgba(0, 0, 0, 0.014),
      0 1.3px 5.3px rgba(0, 0, 0, 0.02), 0 2.5px 10px rgba(0, 0, 0, 0.025),
      0 4.5px 17.9px rgba(0, 0, 0, 0.03), 0 8.4px 33.4px rgba(0, 0, 0, 0.036),
      0 20px 80px rgba(0, 0, 0, 0.05);
  }
  
  .IconBox__Icon {
    margin-right: 10.5px;
    color: #fff !important;
  }
  
  .TextCard__Content {
    font-size: 16px;
    line-height: 160%;
  }

  .recommendation{
    text-align: left;
  }

  .reifegrad {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .recommendation_container {
    margin-bottom: 20px;
  }

/* Responsive */
@media (max-width: 1120px) {
  .kircWrapper {
    margin-top: -20px;
    margin-bottom: -100px;
    padding: 3em 1em 6em 1em;
    min-height: 1000px;
  }
}

@media (max-width: 600px) {
  .answerBoxes {
    padding-bottom: 0em;
  }

  .kircWrapper {
    margin-top: -20px;
    margin-bottom: -100px;
    padding: 0em 0em 3em 0em;
    min-height: 1000px;
  }
}
</style>







// WEBPACK FOOTER //
// src/components/company/kirc/KIRC.vue